import { trpc } from "../../main/components/trpc.ts";
import _ from "underts";

const useAllHoraires = () => {
  const { data: horaires } = trpc.horaire.getAll.useQuery();

  return horaires ? _.sortBy(horaires, "date") : [];
};

export default useAllHoraires;
